<template>
  <div style="background-color: #333; z-index: 1000" class="pb-12">
    <v-container class="pa-12">
      <v-row>
        <v-col xl="3" md="3" lg="3" sm="12" xs="12">
          <v-card flat dark color="transparent">
            <v-card-title style="color: #7D9B38">ANGEBOTE</v-card-title>
            <v-card-text class="pa-0">
              <v-list-item class="white--text">
                <a
                  href="https://www.hausdesstiftens.org/stifter/"
                  target="_blank"
                  >Für Stifter</a
                ></v-list-item
              >
              <v-list-item class="white--text"
                ><a
                  href="https://www.hausdesstiftens.org/unternehmen/"
                  target="_blank"
                  >Für Unternehmen</a
                ></v-list-item
              >
              <v-list-item class="white--text"
                ><a
                  href="https://www.hausdesstiftens.org/non-profits/"
                  target="_blank"
                  >Für Non-Profits</a
                ></v-list-item
              >
            </v-card-text>
          </v-card>
        </v-col>
        <v-col md="6" lg="6" xl="6" sm="12" xs="12">
          <v-row
            ><v-card flat dark color="transparent">
              <v-card-title style="color: #7D9B38" class="hidden-sm-and-down"
                >NEWSLETTER ABONNIEREN</v-card-title
              >
              <v-card-title style="color: #7D9B38" class="hidden-md-and-up"
                >NEWSLETTER <br />
                ABONNIEREN</v-card-title
              >
              <v-card-text class="pa-0">
                <v-list-item class="white--text">
                  <v-btn
                    class="ma-0 hovergreen body-1 hidden-sm-and-down"
                    tile
                    color="#444"
                    dark
                    elevation="0"
                    href="https://www.hausdesstiftens.org/ueber-uns/newsletter/"
                    target="_blank"
                    >Jetzt Themen wählen und anmelden!</v-btn
                  >
                  <v-btn
                    class="ma-0 hovergreen caption hidden-md-and-up"
                    tile
                    color="#444"
                    dark
                    elevation="0"
                    href="https://www.hausdesstiftens.org/ueber-uns/newsletter/"
                    target="_blank"
                    >Jetzt anmelden!</v-btn
                  >
                </v-list-item>
              </v-card-text>
            </v-card></v-row
          >
          <v-row
            ><v-card flat dark color="transparent">
              <v-card-title style="color: #7D9B38">FOLGEN SIE UNS</v-card-title>
              <v-card-text class="pa-0">
                <v-list-item class="text-center">
                  <v-btn
                    class="ma-2 ml-0 hovergreen"
                    fab
                    tile
                    color="#444"
                    dark
                    elevation="0"
                    href="https://www.facebook.com/StifterhelfenHausdesStiftens/"
                    target="_blank"
                    ><v-icon>mdi-facebook</v-icon></v-btn
                  >
                  <v-btn
                    class="ma-2 hovergreen"
                    fab
                    tile
                    color="#444"
                    dark
                    elevation="0"
                    href="https://twitter.com/Stifter_helfen"
                    target="_blank"
                    ><v-icon>mdi-twitter</v-icon></v-btn
                  >
                  <v-btn
                    class="ma-2 hovergreen"
                    fab
                    tile
                    color="#444"
                    dark
                    elevation="0"
                    href="https://www.youtube.com/user/Stifterhelfen"
                    target="_blank"
                    ><v-icon>mdi-youtube</v-icon></v-btn
                  >
                </v-list-item>
              </v-card-text>
            </v-card></v-row
          >
        </v-col>
        <v-col md="3" lg="3" xl="3" sm="12" xs="12" class="mb-12">
          <v-card flat dark color="transparent">
            <v-card-title style="color: #7D9B38">INFO</v-card-title>
            <v-card-text class="pa-0">
              <v-list-item class="white--text">
                <a
                  href="https://www.hausdesstiftens.org/ueber-uns/presse/#kontakt"
                  target="_blank"
                  >Presse</a
                ></v-list-item
              >
              <v-list-item class="white--text">
                <a
                  href="https://www.hausdesstiftens.org/ueber-uns/organisation/"
                  target="_blank"
                  >Organisation</a
                ></v-list-item
              >

              <v-list-item class="white--text">
                <a
                  href="https://www.hausdesstiftens.org/ueber-uns/kontakt/"
                  target="_blank"
                  >Anfahrt/ Kontakt</a
                ></v-list-item
              >
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Hdsinfo"
};
</script>

<style scoped>
.hovergreen:hover:before {
  color: green;
}
.v-btn:focus:before {
  color: green;
}

a {
  color: white !important;
  text-decoration: none !important;
}
a:hover {
  color: #7d9b38 !important;
  text-decoration: none !important;
}
</style>
